<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      title="产品历史销售价格"
      width="800px">
    <div class="first">
      <div class="first-left">
        <div style="display: flex;flex-direction: row;margin-bottom: 5px">
          <div style="padding: 0 1%;font-size: 12px">产品：{{materialName}}</div>
        </div>
        <div style="display: flex;flex-direction: row;margin: 1% 0">
          <div style="padding: 0 1%;font-size: 12px">申请价格：{{approve3Price}}</div>
        </div>
      </div>
      <div class="first-right">
        <div class="first-right-div">
          <div class="first-right-div-word">最高执行价</div>
          <div style="color: #2D8CF0;font-size: 14px">{{max}}</div>
        </div>
        <div class="first-right-div">
          <div v-if="approve3Price>=min && approve3Price<=max">
            <el-progress :show-text="false" :stroke-width="20" :percentage="100" class="el-bg-inner-running"/>
            <div :style="{left: percentage1+'%',color:color}" class="first-right-div-last">
              <i class="el-icon-caret-top"/>
              <div>当前申请价:<span class="number">{{approve3Price}}</span></div>
            </div>
          </div>
          <div v-else-if="approve3Price<min">
            <el-progress :show-text="false" :stroke-width="20" :percentage="100" class="el-bg-inner-running"/>
            <div style="left: 100%" class="first-right-div-last">
              <i class="el-icon-caret-top"/>
              <div>当前申请价:<span>{{approve3Price}}</span>小于所有执行价</div>
            </div>
          </div>
          <div v-else>
            <el-progress :show-text="false" :stroke-width="20" :percentage="100" class="el-bg-inner-running"/>
            <div style="color: #4e5dcd" class="first-right-div-last">
              <i class="el-icon-caret-top"/>
              <div>当前申请价:<span>{{approve3Price}}</span>大于所有执行价</div>
            </div>
          </div>
        </div>
        <div class="first-right-div">
          <div class="first-right-div-word">最低执行价</div>
          <div style="color: red;font-size: 14px">{{min}}</div>
        </div>
      </div>
    </div>
    <Table
        border
        stripe
        :data="data"
        :columns="columnsProperty"/>
  </el-dialog>
</template>

<script>
  export default {
    name:"BusinessApplicationMaterialPreview",
    components:{},
    data() {
      return {
        dialogVisible:false,
        min:0,
        max:0,
        approve3Price:0,
        percentage1:10,
        materialName:"",
        color: "#fffe00",
        data:[],
        columnsProperty:[
          {
            title:"销售订单编号",
            key:"salesOrderNo",
            align:"center",
          },
          {
            title:"创建时间",
            key:"salesOrderCreateTime",
            align:"center",
          },
          {
            title:"创建人",
            key:"salesOrderCreatorName",
            align:"center",
          },
          {
            title:"价格",
            key:"price",
            align:"center",
          },
        ],
      };
    },
    methods:{
      open(id,row) {
        console.log(row);
        this.max = 0;
        this.min = 0;
        this.percentage1 = 10;
        this.approve3Price = row.approve3Price;
        this.materialName = row.materialName;
        this.dialogVisible = true;
        this.$http.get("basic",`sd/so/getOrderDetailByCust/${id}/${row.productID}`).then((res)=>{
          console.log(res);
          this.data = res.data;
          if(res.data.length) {
            this.max = res.data[0].price;
            this.min = res.data[0].price;
            res.data.forEach(item=>{
              if(item.price > this.max) {
                this.max = item.price;
              }else if(item.price < this.min) {
                this.min = item.price;
              }
            });
          }
          let leg1 = this.max - this.min;
          if (this.approve3Price<=this.max && this.approve3Price>=this.min) {
            let leg2 = this.max - this.approve3Price;
            this.percentage1 = (leg2/leg1).toFixed(2)*100;
          }else {
            this.percentage1 = 0;
          }
          if (70<=this.percentage1 && this.percentage1<=100) {
            this.color = "#606266";
            console.log("111111");
            this.class1 = "el-bg-inner-running";
          } else if (40<=this.percentage1 && this.percentage1 <70) {
            this.color = "#606266";
            console.log("222222");
            this.class1 = "el-bg-inner-error";
          } else  {
            this.color = "#606266";
            console.log("3333333");
            this.class1 = "el-bg-inner-done";
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.first{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px 30px 10px;
  border: 1px solid #eeeeee;
  border-bottom: none;
  border-top: none;
  .first-left{
    width: 35%;
  }
  .first-right{
    width: 62%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .first-right-div{
      font-size: 12px;
      text-align: center;
      position: relative;
      .first-right-div-word{
        margin-bottom: 5px;
      }
      .first-right-div-last-left{
        position: absolute;
        top: 30px;
        left: -65px;
        color: red;
      }
      .first-right-div-last-right{
        position: absolute;
        top: 30px;
        right: -65px;
        color: red;
      }
      .first-right-div-last{
        position: absolute;
        top: 15px;
        transform: translateX(-50%);
        color: red;
        i{
          display: block;
        }
        div{
          width: 185px;
          position: absolute;
          left: -80px;
          top: 12px;
        }
      }
    }
    .first-right-div:nth-child(2){
      width: 65%;
      margin: 0 2%;
    }
  }
}
/* 渐变进度条 */
.el-bg-inner-running .el-progress-bar__inner{
  background-color: unset;
  background-image:linear-gradient(to right, #4e5dcd,#6778b1,#fffe00,#ff0000)!important;
}
.el-bg-inner-error .el-progress-bar__inner{
  background-color: unset;
  background-image:linear-gradient(to right, #4e5dcd,#6778b1,#fffe00)!important;
}
.el-bg-inner-done .el-progress-bar__inner{
  background-image:linear-gradient(to right, #4e5dcd,#6778b1)!important;
}
</style>